export type BoardingGuide = {
  title: string;
  description: string;
  fileName: string;
  link: string;
};

/**
 * Route based onboarding guides shown by ModalPresentation.
 * The key must match the route name the guide belongs to.
 */
export const useBoardingGuides = () => {
  const { t } = useI18n();
  const route = useRoute();
  const presentationStore = usePresentationStore();

  const boardingGuides: Record<string, BoardingGuide> = {
    shipments: {
      title: t("introductions.shipments.title"),
      description: t("introductions.shipments.description"),
      fileName: "shipments",
      link: "https://help.homerunner.com/",
    },
    returns: {
      title: t("introductions.returns.title"),
      description: t("introductions.returns.description"),
      fileName: "returns",
      link: "https://help.homerunner.com/",
    },
    tickets: {
      title: t("introductions.tickets.title"),
      description: t("introductions.tickets.description"),
      fileName: "tickets",
      link: "https://help.homerunner.com/",
    },
    "sortings-terminal": {
      title: t("introductions.sortings_terminal.title"),
      description: t("introductions.sortings_terminal.description"),
      fileName: "new_smw_sorting",
      link: "https://help.homerunner.com/",
    },
    sortings: {
      title: t("introductions.sortings.title"),
      description: t("introductions.sortings.description"),
      fileName: "new_enterprise_sorting",
      link: "https://help.homerunner.com/",
    },
    "shipments-id": {
      title: t("introductions.shipment.title"),
      description: t("introductions.shipment.description"),
      fileName: "shipments_detail_page",
      link: "https://help.homerunner.com/",
    },
  };

  const currentBoardingGuide = computed(() => {
    const routeKey = route.name as string;

    if (!routeKey) return null;
    if (presentationStore.seenGuides.includes(routeKey)) return null;

    return boardingGuides[routeKey] || null;
  });

  const markCurrentGuideAsSeen = () => {
    const routeKey = route.name as string;

    if (!routeKey) return;
    if (presentationStore.seenGuides.includes(routeKey)) return;

    presentationStore.addSeenGuide(routeKey);
  };

  return {
    boardingGuides,
    currentBoardingGuide,
    markCurrentGuideAsSeen,
  };
};
